<template >
  <el-dialog
    :title="'岗点人员'"
    :close-on-click-modal="false"
    :visible.sync="visible">
    <div id="left">
      <el-table
              :data="dataList"
              border
              style="width: 100%;">
        <el-table-column
                prop="xm"
                header-align="center"
                align="center"
                show-overflow-tooltip
                label="姓名">
        </el-table-column>
        <el-table-column
                show-overflow-tooltip
                prop="zzdyqc"
                header-align="center"
                align="center"
                label="部门">
        </el-table-column>
        <el-table-column
                prop="sjhm"
                header-align="center"
                align="center"
                width="180"
                label="手机号">
        </el-table-column>
        <el-table-column
                prop="isTemp"
                header-align="center"
                align="center"
                width="180"
                label="临时">
          <template slot-scope="scope">
            <span>{{scope.row.isTemp==0?'否':'是'}}</span>
          </template>
        </el-table-column>
        <el-table-column fixed="right" label="操作" :render-header="renderHeader">
          <template slot-scope="scope">
            <el-row>
              <el-button type="text" v-if="isAuth('gangdian:setuser')" @click="removeUser(scope.row)">移除</el-button>

            </el-row>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
              @current-change="currentChangeHandle"
              :current-page="pageIndex"
              :page-size="pageSize"
              :total="totalPage"
              layout="total, prev, pager, next">
      </el-pagination>
    </div>
    <el-dialog
            style="text-align: left"
            title="导出"
            :visible.sync="exportVisible"
            append-to-body
    >
      <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">全选</el-checkbox>
      <el-checkbox-group v-model="fieldList" @change="handleCheckedItemChange">
        <el-checkbox v-for="field in fields" :label="field.value" :key="field.value">{{field.name}}</el-checkbox>
      </el-checkbox-group>
      <form ref="exportForm" method="post" :action="this.$request.defaults.baseURL+'/bjba/map/exportGdUserExcel?access_token='+this.$store.getters.token"  target="_blank">
        <input type="hidden" name="gdid"  :value="id" />
        <input type="hidden" name="fileds" value="" ref="fileds"/>
      </form>
      <span slot="footer" class="dialog-footer">
    <el-button @click="exportVisible = false">取 消</el-button>
    <el-button type="primary" @click="exportExcel">确 定</el-button>
  </span>
    </el-dialog>
    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">取消</el-button>

    </span>
  </el-dialog>
</template>

<script>


  import Template from "@/template";
  const exportFields=[
    {value:"username",name:"工号"},
    {value:"xm",name:"姓名"},
    {value:"xb",name:"性别"},
    {value:"sjhm",name:"手机号码"},
    {value:"jrgsrq",name:"进入公司日期"},
    {value:"jyxz",name:"就业性质"},
    {value:"ly",name:"来源"},
    {value:"pxqk",name:"培训情况"},
    {value:"mz",name:"民族"},
    {value:"whcd",name:"文化程度"},
    {value:"ygxz",name:"用工性质"},
    {value:"zzdyqc",name:"部门"},
    {value:"gw",name:"职位"}
  ]
  export default {
    components: {Template},
    data () {
      return {
        visible: false,
        pageIndex: 1,
        pageSize:10,
        totalPage: 0,
        id: 0,
        dataList:[],
        isIndeterminate:false,
        exportVisible:false,
        checkAll:false,
        fields:exportFields,
        filedValues:exportFields.map(item => item.value),
        fieldList:[]
      }
    },
    created () {

    },
    methods: {
      init (id) {
        this.id =id
        this.dataList=[]
        this.pageIndex=1;
        this.totalPage=0;
        this.visible = true
          this.getDataList()
      },
      handleCheckAllChange(val) {
        this.fieldList = val ? this.filedValues: [];
        this.isIndeterminate = false;
      },
      handleCheckedItemChange(value) {
        let checkedCount = value.length;
        this.checkAll = checkedCount === this.filedValues.length;
        this.isIndeterminate = checkedCount > 0 && checkedCount < this.fields.length;
      },
      showExportDialog() {
        this.exportVisible = true
      },
      renderHeader (h) {
        return (
                <div class="clearfix">
                  <span>操作</span>
                  <el-button style="padding:5px;float:right" size="mini"
                             onClick={()=>this.showExportDialog()}>导出</el-button></div>
        )
      },
      exportExcel() {

        var filedLast = this.fields.filter(filed=>{
          return this.fieldList.indexOf(filed.value) !==-1
        })
        if(filedLast && filedLast.length>0) {
          this.$refs.fileds.value = JSON.stringify(filedLast)
          this.$refs.exportForm.submit();
        } else {
          this.$message({
            message: '请选择字段',
            type: 'error',
            duration: 1500
          })
          return
        }
      },
      currentChangeHandle (val) {
        this.pageIndex = val
        this.getDataList()
      },
      getDataList() {
        this.$request({
          url: '/bjba/map/userList',
          method: 'get',
          params: {
            'page': this.pageIndex,
            'pageSize': this.pageSize,
            'id': this.id
          }
        }).then(response => {
          console.log('aaaaaaaaaaaaaa'+response)
          this.dataList = response.data.data.list;
          this.totalPage = response.data.data.total;
        }).catch(error => {
          console.log(error)
        });
      },
      removeUser(user){
        this.$confirm('确定要移除此用户', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$request({
            method: 'post',
            url: '/bjba/map/removeUser',
            params: {
              gdid:this.id,
              userid:user.id,
              isTemp:user.isTemp
            }
          }).then((response) => {
            this.$message.success("移除成功！");
            this.getDataList();
          }).catch(err => {
            console.log(err)
            alert("删除失败！")
          })
        }).catch(() => {});
      }
    }
  }
</script>

<style lang="scss" >
  #left .el-form-item__content{
    text-align: left;
  }
  .menu-list__input,
  .icon-list__input {

    > .el-input__inner {
      cursor: pointer;
    }

  }

  .mod-menu__icon-popover {
    max-width: 350px;
  }

  .mod-menu__icon-list {
    max-height: 380px;
    padding: 0;
    margin: -8px 0 0 -8px;

    > .el-button {
      padding: 8px;
      margin: 8px 0 0 8px;

      > span {
        display: inline-block;
        vertical-align: middle;
        width: 18px;
        height: 18px;
        font-size: 18px;
      }

    }
  }

  .icon-list__tips {
    font-size: 18px;
    text-align: center;
    color: #e6a23c;
    cursor: pointer;
  }
</style>
